import ApiClient from "./ApiClient";
import { redirectTo } from "../utils/browserUtils";

export class PrivateBackendApiClient extends ApiClient {
  redirectToSessionExpiredOnAuthError: $TSFixMe;

  constructor(
    baseUrl: $TSFixMe,
    options: $TSFixMe,
    redirectToSessionExpiredOnAuthError = true,
    useNewErrors = false,
  ) /* istanbul ignore next */ {
    super(baseUrl, options);
    this.redirectToSessionExpiredOnAuthError =
      redirectToSessionExpiredOnAuthError;
    this.useNewErrors = useNewErrors;
  }

  handleError(error: $TSFixMe, request: $TSFixMe) {
    if (
      error.response &&
      error.response.status === 401 &&
      this.redirectToSessionExpiredOnAuthError
    ) {
      redirectTo("/session_expired");
      return new Promise((resolve, reject) => reject());
    }
    /* istanbul ignore next */
    return super.handleError(error, request);
  }
}

export default function backendApiClient(
  redirectToSessionExpiredOnAuthError = true,
  useNewErrors = false,
  responseType = null,
) /* istanbul ignore next */ {
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  const baseUrl = `${document.location.protocol}//${document.location.host}${global.configuration.backendApiUrl}`;
  const csrfToken = document.head.querySelector("[name=csrf-token]");
  const headers = { "Content-Type": "application/json" };

  //  test needed for capybara tests where no csrf token is present
  if (csrfToken) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    headers["X-CSRF-Token"] = (csrfToken as $TSFixMe).content;
  }

  const options = { withCredentials: true, headers };
  if (responseType) {
    (options as $TSFixMe).responseType = responseType;
  }

  return new PrivateBackendApiClient(
    baseUrl,
    options,
    redirectToSessionExpiredOnAuthError,
    useNewErrors,
  );
}
